import { Helmet } from 'react-helmet-async';
import DishCategoryListView from 'src/sections/dishcategory/view/dishcategory-list-view';
// sections

// ----------------------------------------------------------------------

export default function DishCategoryListPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Categoria de Pratos</title>
      </Helmet>

      <DishCategoryListView />
    </>
  );
}
